import { PRIORITY_COLORS, PRIORITY_LABELS } from './incidentLabels';
import type { IncidentPriority } from '../../types/extranet-api.types';

interface IncidentPriorityIndicatorProps {
  priority: IncidentPriority;
}

export const IncidentPriorityIndicator = ({ priority }: IncidentPriorityIndicatorProps) => {
  const tokens = PRIORITY_COLORS[priority];
  return (
    <span className={`inline-flex items-center gap-2 text-sm ${tokens.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${tokens.dot}`} aria-hidden />
      {PRIORITY_LABELS[priority]}
    </span>
  );
};
